import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import AppBar from "./components/AppBar";
import PollComponent from "./components/Polling";
import QueryHistory from "./components/QueryHistory";
import LoadingModal from "./components/LoadingModal";
import LanguageModal from "./components/LanguageModal";
import ExplainerModal from "./components/ExplainerModal";
import Footer from "./components/Footer";
import AboutPage from "./pages/AboutPage";
import RegisterPage from "./pages/RegisterPage";
import AccountPage from "./pages/AccountPage";
import HomePage from "./pages/HomePage";
import HomePageRedirect from "./pages/HomePageRedirect";
import SubscriptionPage from "./pages/SubscriptionPage";
import TermsOfService from "./pages/legal/TermsOfService";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import { translations } from "./translations";
import axios from "axios";
import "./App.css";
import Cookies from "js-cookie";
import { useSnackbar } from "notistack";

const languageOptions = {
  "en-IN": "english",
  "ml-IN": "malayalam",
  // "hi-IN": "hindi",
  // "bn-IN": "bengali",
  // "kn-IN": "kannada",
  // "mr-IN": "marathi",
  // "ta-IN": "tamil",
  // "te-IN": "telugu",
  // "gu-IN": "gujurati",
  // "pa-Guru-IN": "punjabi",
};
// This exists for the LanguageModal ONLY
const languageTranslations = {
  english: "English",
  malayalam: "മലയാളം",
  // hindi: "हिंदी",
  // bengali: "বাংলা",
  // kannada: "ಕನ್ನಡ",
  // marathi: "मराठी",
  // tamil: "தமிழ்",
  // telugu: "తెలుగు",
  // gujurati: "ગુજરાતી",
  // punjabi: "ਪੰਜਾਬੀ",
};
const languageCodes = {
  english: "en-IN",
  malayalam: "ml-IN",
  // hindi: "hi-IN",
  // bengali: "bn-IN",
  // kannada: "kn-IN",
  // marathi: "mr-IN",
  // tamil: "ta-IN",
  // telugu: "te-IN",
  // gujurati: "gu-IN",
  // punjabi: "pa-Guru-IN",
};

export const getNavProps = () => {
  let navProps = [];
  for (let prop in window.navigator) {
    navProps.push({ [prop]: window.navigator[prop] });
  }
  return { navProps, navPropsLength: navProps.length };
};
export const sendErrorToServer = async (errorObj, additionalInfo = {}) => {
  const navProps = getNavProps();
  const combinedErrorObj = {
    ...errorObj,
    ...additionalInfo,
    navProps,
  };

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/api/error`,
    combinedErrorObj
  );
};
function App() {
  const { enqueueSnackbar } = useSnackbar();
  let language = Cookies.get("language");

  const navigate = useNavigate();
  const location = useLocation();

  axios.defaults.withCredentials = true;

  const toggleLanguage = () => {
    setSiteLanguage((prevLanguage) =>
      prevLanguage === "english" ? "malayalam" : "english"
    );
  };
  const guestOrUserFetch = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/guestOrUser`
      );
      if (response.data == true) {
        setguestOrUser("user");
        return "user";
      } else {
        setguestOrUser("guest");
        return "guest";
      }
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error fetching logged in status:", error);
    }
  };

  const fetchGuestRequestStats = async () => {
    try {
      const navProps = getNavProps();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/guest/requests`,
        navProps
      );
      setRequestStats(response.data);
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error fetching request stats: ", error);
    }
  };
  const fetchGuestNumber = async () => {
    try {
      const navProps = getNavProps();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/guest-order-number`,
        navProps
      );
      setGuestNumber(response.data);
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error fetching request stats: ", error);
    }
  };
  const fetchUserRequestStats = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/user/requests`
      );
      setRequestStats(response.data);
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error fetching request stats: ", error);
    }
  };
  const fetchSubscriptionStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/subscriber-status`
      );
      // console.log("Subscriber Status: ", response.data);
      setSubscriptionStatus(response.data);
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error fetching subscription status: ", error);
    }
  };
  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/user/logout`);
      setguestOrUser("guest");
      fetchGuestRequestStats();
      handleClear();
      window.location.href = "/";
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error during logout:", error);
    }
  };
  const handleClear = () => {
    setAudioData(null);
    setUserTranscription("");
    setQueryTranslation("");
    setEnglish("");
    setMalayalam("");
    setShowTranslateButton(true);
    setShowResults(false);
    setShowSuggestions(true);
    setIsPulsating(true);
    setIsReadyClicked(false);
    setRecording(false);
  };
  const handleRefresh = () => {
    window.location.reload();
  };

  const [recording, setRecording] = useState(false);
  const [isReadyClicked, setIsReadyClicked] = useState(false);

  const [audioData, setAudioData] = useState(null);
  const [english, setEnglish] = useState("");
  // Transcription of the user's query
  const [userTranscription, setUserTranscription] = useState("");
  // Translation, if applicable, of the user's query
  const [queryTranslation, setQueryTranslation] = useState("");
  const [showTranslateButton, setShowTranslateButton] = useState(true);
  const [malayalam, setMalayalam] = useState("");
  const [audioKey, setAudioKey] = useState(0);
  const [requestStats, setRequestStats] = useState({ count: 0, limit: 0 });
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [siteLanguage, setSiteLanguage] = useState(
    Cookies.get("language") || "english"
  );
  const [guestOrUser, setguestOrUser] = useState("guest");
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);
  const [languageCode, setLanguageCode] = useState("en-IN");
  const [helperText, setHelperText] = useState("");
  const [voiceGender, setVoiceGender] = useState("Female");
  const [isPulsating, setIsPulsating] = useState(true);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showExplainerModal, setShowExplainerModal] = useState(false);
  const [hasSeenExplainer, setHasSeenExplainer] = useState(
    Cookies.get("explainerDone") === "true"
  );
  const [hasSeenLanguageModel, sethasSeenLanguageModel] = useState(
    Cookies.get("language")
  );
  const [showQuestionHistory, setShowQuestionHistory] = useState(true);
  const [guestNumber, setGuestNumber] = useState(0);

  useEffect(() => {
    let timer;
    // console.log("useEffect log");
    guestOrUserFetch().then((status) => {
      // console.log("Status:", status);
      if (status === "guest") {
        fetchGuestRequestStats();
      } else {
        fetchUserRequestStats();
      }
      fetchSubscriptionStatus();
      timer = setTimeout(() => {
        setLoadingScreen(false);
        setShowLanguageModal(true);
      }, 1000);
    });
    fetchGuestNumber();

    // Clean up function to clear the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    Cookies.set("language", siteLanguage, { expires: 7 });
    setLanguageCode(languageCodes[siteLanguage]);
    setHelperText(translations[siteLanguage].helperText);
    if (location.pathname === "/") {
      navigate(`/${siteLanguage}`);
    }
  }, [siteLanguage, location.pathname]);

  useEffect(() => {
    handleClear();
  }, [location.pathname]);

  const handleLanguageModalClose = (language) => {
    setShowLanguageModal(false);
    if (language) {
      setSiteLanguage(language);
    }
    setShowExplainerModal(true);
  };
  const handleExplainerModalClose = () => {
    setShowExplainerModal(false);
    Cookies.set("explainerDone", true, { expires: 7 });
  };
  const handleRecordingComplete = async (blob) => {
    setLoading(true);
    setIsPulsating(false);
    setHelperText(translations[siteLanguage].recordingFinished);
    // console.log("HANDLE RECORDING COMPLETE");
    setShowSuggestions(false);

    const formData = new FormData();
    formData.append("audio", blob);

    const navProps = getNavProps();
    formData.append("navProps", JSON.stringify(navProps));
    formData.append("languageCode", languageCode);
    formData.append("voiceGender", voiceGender);

    try {
      if (guestOrUser === "guest") {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/guest/audio`,
          formData
        );
        // console.log(response.data);

        setUserTranscription(response.data.transcription);
        setQueryTranslation(response.data.englishTranslation);
        setAudioData(response.data.audioData);
        setEnglish(response.data.gptResponseEnglish);
        setMalayalam(response.data.gptResponseOutput);
        setAudioKey((prevKey) => prevKey + 1);
        setLoading(false);
        setShowResults(true);
        fetchGuestRequestStats();
        setHelperText(translations[siteLanguage].helperText);
      } else {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/user/audio`,
          formData
        );

        setUserTranscription(response.data.transcription);
        setQueryTranslation(response.data.englishTranslation);
        setAudioData(response.data.audioData);
        setEnglish(response.data.english);
        setMalayalam(response.data.gptResponseOutput);
        setAudioKey((prevKey) => prevKey + 1);
        setLoading(false);
        setShowResults(true);
        fetchUserRequestStats();
        setHelperText(translations[siteLanguage].helperText);
      }
    } catch (error) {
      await sendErrorToServer(error);
      console.error("Error uploading audio: ", error);
    }
  };

  return (
    <div className="AppApp">
      <LoadingModal open={loadingScreen} />
      {!hasSeenLanguageModel && (
        <LanguageModal
          showLanguageModal={showLanguageModal}
          handleLanguageModalClose={handleLanguageModalClose}
          languageOptions={languageOptions}
          languageTranslations={languageTranslations}
        />
      )}

      {!hasSeenExplainer && (
        <ExplainerModal
          showExplainerModal={showExplainerModal}
          handleExplainerModalClose={handleExplainerModalClose}
          translations={translations}
          siteLanguage={siteLanguage}
        />
      )}

      <AppBar
        toggleLanguage={toggleLanguage}
        handleLogout={handleLogout}
        guestOrUser={guestOrUser}
        subscriptionStatus={subscriptionStatus}
        languageTranslations={languageTranslations}
      />
      {/* <QueryHistory
        getNavProps={getNavProps}
        sendErrorToServer={sendErrorToServer}
      /> */}
      <Routes>
        <Route
          path="/about"
          element={<AboutPage siteLanguage={siteLanguage} />}
        />
        <Route
          path="/subscribe"
          element={<SubscriptionPage siteLanguage={siteLanguage} />}
        />
        <Route
          path="/account"
          element={
            <AccountPage
              siteLanguage={siteLanguage}
              subscriptionStatus={subscriptionStatus}
              setSubscriptionStatus={setSubscriptionStatus}
            />
          }
        />
        <Route
          path="/register"
          element={
            <RegisterPage
              siteLanguage={siteLanguage}
              fetchUserRequestStats={fetchUserRequestStats}
              handleClear={handleClear}
            />
          }
        />
        <Route
          path="/login"
          element={
            <RegisterPage
              siteLanguage={siteLanguage}
              fetchUserRequestStats={fetchUserRequestStats}
              handleClear={handleClear}
            />
          }
        />
        <Route
          path="/terms"
          element={<TermsOfService siteLanguage={siteLanguage} />}
        />

        <Route
          path="/privacy"
          element={<PrivacyPolicy siteLanguage={siteLanguage} />}
        />
        <Route
          path="/"
          element={<HomePageRedirect siteLanguage={siteLanguage} />}
        />
        <Route
          path="/:language"
          element={
            <HomePage
              languageCode={languageCode}
              setLanguageCode={setLanguageCode}
              handleRecordingComplete={handleRecordingComplete}
              loading={loading}
              setLoading={setLoading}
              handleClear={handleClear}
              guestOrUser={guestOrUser}
              requestStats={requestStats}
              showResults={showResults}
              showSuggestions={showSuggestions}
              userTranscription={userTranscription}
              queryTranslation={queryTranslation}
              setShowTranslateButton={setShowTranslateButton}
              showTranslateButton={showTranslateButton}
              helperText={helperText}
              setHelperText={setHelperText}
              setShowSuggestions={setShowSuggestions}
              audioData={audioData}
              audioKey={audioKey}
              setMalayalam={setMalayalam}
              malayalam={malayalam}
              english={english}
              siteLanguage={siteLanguage}
              setSiteLanguage={setSiteLanguage}
              translations={translations}
              subscriptionStatus={subscriptionStatus}
              languageOptions={languageOptions}
              languageCodes={languageCodes}
              setVoiceGender={setVoiceGender}
              voiceGender={voiceGender}
              isPulsating={isPulsating}
              setIsPulsating={setIsPulsating}
              setRecording={setRecording}
              recording={recording}
              setIsReadyClicked={setIsReadyClicked}
              isReadyClicked={isReadyClicked}
              handleRefresh={handleRefresh}
              QueryHistory={QueryHistory}
              getNavProps={getNavProps}
              sendErrorToServer={sendErrorToServer}
              setShowQuestionHistory={setShowQuestionHistory}
              showQuestionHistory={showQuestionHistory}
              guestNumber={guestNumber}
            />
          }
        />
        <Route
          path="*"
          element={<HomePageRedirect siteLanguage={siteLanguage} />}
        />
      </Routes>
      <Footer className="Footer" guestNumber={guestNumber} />
    </div>
  );
}

export default App;
